<template>
  <v-card class="pt-8 mb-4 px-5" elevation="1">
    <v-form ref="form" @submit.prevent="refreshData">
      <v-container fluid>
        <v-row justify="space-between">
          <v-col cols="12" sm="6" md="2" lg="2" xl="2">
            <v-select
              v-model="selectedBuildingType"
              :items="building_type"
              label="Building type"
              item-text="label"
              item-value="name"
              outlined
              required
              dense
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="2" lg="2" xl="2">
            <v-select
              v-model="selectedFunitTypes"
              :items="functional_unit_type"
              label="Functional unit type"
              item-text="label"
              item-value="name"
              outlined
              required
              dense
              clearable
              multiple
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="2" lg="2" xl="2">
            <v-select
              v-model="selectedBuildingTypeUsages"
              :items="building_type_usage"
              label="Usage type"
              item-text="label"
              item-value="name"
              outlined
              required
              dense
              clearable
              multiple
            />
          </v-col>
          <v-col sm="3" md="2" lg="2" xl="2">
            <v-select
              v-model="renovation_year_from"
              :items="yearOptions"
              label="Renovation start year"
              outlined
              dense
              clearable
            ></v-select>
          </v-col>
          <v-col sm="3" md="2" lg="2" xl="2">
            <v-select
              v-model="renovation_year_to"
              :items="yearOptions"
              label="Renovation end year"
              outlined
              dense
              clearable
            ></v-select>
          </v-col>
          <v-col sm="3" md="2" lg="1" xl="1" style="text-align: center">
            <div class="d-flex justify-end">
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon @click="clearFilters"
                      ><v-icon size="36">mdi-close</v-icon></v-btn
                    >
                  </template>
                  <span>Clear all filters</span>
                </v-tooltip>
              </div>
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon type="submit"
                      ><v-icon size="36">mdi-refresh</v-icon></v-btn
                    >
                  </template>
                  <span>Refresh</span>
                </v-tooltip>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import utility from "../utility/utility";
import EventBus from "../components/EventBus";

export default {
  mounted: function () {
    this.setYearOptions();
    this.setCodebookData();
    EventBus.$on("logout", () => {
      this.$refs.form.reset();
    });
  },
  data() {
    return {
      selectedBuildingType: null,
      selectedFunitTypes: null,
      selectedBuildingTypeUsages: null,
      renovation_year_from: null,
      renovation_year_to: null,

      building_type_usage: null,
      building_type: null,
      functional_unit_type: null,

      yearOptions: [],

      codebooksToExtract: [
        "building_type",
        "building_type_usage",
        "functional_unit_type",
      ],
    };
  },
  methods: {
    clearFilters: function () {
      this.$refs.form.reset();
      this.refreshData();
    },
    setCodebookData: function () {
      const codebooks = JSON.parse(
        sessionStorage.getItem("dbData")
      ).enum_constants_lookup;
      this.codebooksToExtract.forEach((name) => {
        this[name] = codebooks[name].map((table, index) => {
          return {
            id: index,
            name: table,
            label: utility.convertStrToLabel(table),
          };
        });
      });
    },
    refreshData: function () {
      //emiting params for functional-units/search
      this.$emit("refreshData", {
        building_type: this.selectedBuildingType,
        functional_unit_types: this.getVal(this.selectedFunitTypes),
        building_type_usages: this.getVal(this.selectedBuildingTypeUsages),
        renovation_year_from: parseInt(this.renovation_year_from),
        renovation_year_to: parseInt(this.renovation_year_to),
      });
    },
    getVal: (val) => (val && val.length > 0 ? val : null),
    setYearOptions: function () {
      // generate options for years starting from current year - 100 years
      const currentYear = new Date().getFullYear();
      for (let i = currentYear; i >= currentYear - 100; i--) {
        this.yearOptions.push(i.toString());
      }
    },
  },
};
</script>

<style scoped></style>
